import React from 'react';
import { useLocation } from 'react-router-dom';

const GoogleCalendarCallback = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const message = query.get('message');

  return (
    <div>
      <h1>Google Calendar</h1>
      <p>Google Calendar Integration Status: {message}</p>
      <button
        onClick={() => {
          window.close();
        }}
        className="btn btn-primary">
        Close
      </button>
    </div>
  );
};

export default GoogleCalendarCallback;
